import { render } from "./Kpis.vue?vue&type=template&id=3bc2499c&scoped=true"
import script from "./Kpis.vue?vue&type=script&lang=js"
export * from "./Kpis.vue?vue&type=script&lang=js"

import "./Kpis.vue?vue&type=style&index=0&id=3bc2499c&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc2499c"]])

export default __exports__